  function sortEventListings() {
  document.addEventListener('DOMContentLoaded', function() {
  const eventsContainer = document.querySelector('.collection-products');
  if (!eventsContainer) return;

  const events = Array.from(eventsContainer.children);
  const eventProducts = events.filter(event => {
    const startDate = event.dataset.startDate;
    return startDate;
  });

  if (eventProducts.length === 0) return;

  eventProducts.sort((a, b) => {
    const dateA = new Date(a.dataset.startDate);
    const dateB = new Date(b.dataset.startDate);
    return dateA - dateB;
  });

  eventProducts.forEach(product => {
    eventsContainer.appendChild(product);
  });
});
}
sortEventListings();